<div class="d-flex lcl-dashboard-shipment-card">
  <div class="shipment-card-tracking-container">
    <app-lcl-header-detailed-info
      class="border-bottom-custom"
      [template]="enumDetailedInfoPlacementEnum.shipmentDashboardTemplate"
      [isDashboardPlacement]="true"
      [isQuote]="false"
      [referenceValue]="shipment?.referenceNumber"
      [referenceName]="referenceTitleKey"
      [info]="shipment"
    ></app-lcl-header-detailed-info>
    <app-lcl-shipment-tracking-state
      class="border-bottom-custom"
      [currentState]="shipment?.trackingState"
    ></app-lcl-shipment-tracking-state>
    <app-lcl-shipment-voyage-info [shipment]="shipment"></app-lcl-shipment-voyage-info>
  </div>
  <div class="shipment-card-totals-container">
    <app-lcl-shipment-totals-info [aggregatedStatistics]="shipment?.aggregatedStatistics"></app-lcl-shipment-totals-info>
  </div>
</div>
